export const RoutesLink = [
  {
    path: "/",
    name: "Home",
    component: "Home",
    isPrivate: false,
    role: "",
  },
  {
    path: "/about",
    name: "About",
    component: "About",
    isPrivate: false,
  },
  { path: "/brand", name: "Brand", component: "Brand", isPrivate: false },
  {
    path: "/influencer",
    name: "Influencer",
    component: "Influencer",
    isPrivate: false,
  },
  { path: "/login", name: "Login", component: "Login", isPrivate: false },
  {
    path: "/contact",
    name: "Contact Us",
    component: "Contact",
    isPrivate: false,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: "PrivacyPolicy",
    isPrivate: false,
  },
  {
    path: "/cookie-policy",
    name: "Cookie Policy",
    component: "CookiePolicy",
    isPrivate: false,
  },
  {
    path: "/terms-condition",
    name: "Terms & Conditions",
    component: "TermsAndConditions",
    isPrivate: false,
  },
  {
    path: "/user-agreement",
    name: "User Agreement",
    component: "UserAgreement",
    isPrivate: false,
  },
  { path: "/policy", name: "Policy", component: "Policy", isPrivate: false },
  {
    path: "/copy-rights",
    name: "Copy Rights",
    component: "CopyRights",
    isPrivate: false,
  },
  {
    path: "/brand-home",
    name: "Brand Home",
    component: "BrandHome",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/campaign",
    name: "Campaign",
    component: "Campaign",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/campaign-create",
    name: "CampaignCreate",
    component: "CampaignCreate",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/campaign-create/:id",
    name: "CampaignCreate",
    component: "CampaignCreate",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/insightsHome",
    name: "InsightsHome",
    component: "InsightsHome",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/insightsDeliverables/:id",
    name: "insightsDeliverables",
    component: "insightsDeliverables",
    isPrivate: true,
    role: "brand",
  },

  {
    path: "/campaign-details/:id",
    name: "CampaignDetails",
    component: "CampaignDetails",
    isPrivate: true,
    role: "brand",
  },

  {
    path: "/influencer/:userId",
    name: "InfluencerDetails",
    component: "InfluencerDetails",
    isPrivate: true,
  },
  {
    path: "/influencer-home",
    name: "influencerHome",
    component: "influencerHome",
    isPrivate: true,
    role: "influencer",
  },

  {
    path: "/campaign-influencer",
    name: "campaignInfluencer",
    component: "campaignInfluencer",
    isPrivate: true,
    role: "influencer",
  },
  {
    path: "/dashboard-influencer",
    name: "DashboarInfluencer",
    component: "DashboarInfluencer",
    isPrivate: true,
    role: "influencer",
  },

  {
    path: "/insights/youtube",
    name: "YouTube Insights",
    component: "YoutubeInsights",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/insights/instagram",
    name: "Instagram Insights",
    component: "InstagramInsights",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/message",
    name: "message",
    component: "Message",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/ContractforCollaboration/:id",
    name: "ContractforCollaboration",
    component: "ContractforCollaboration",
    isPrivate: true,
    role: "brand",
  },

  {
    path: "/phone-email",
    name: "phoneemail",
    component: "LoginWithPhoneOrEmail",
    isPrivate: false,
  },
  {
    path: "/phone",
    name: "loginwithphoone",
    component: "LoginWithPhone",
    isPrivate: false,
  },
  {
    path: "/email",
    name: "loginwithemail",
    component: "LoginWithEmail",
    isPrivate: false,
  },
  {
    path: "/otp",
    name: "otpverification",
    component: "OtpVerification",
    isPrivate: false,
  },
  {
    path: "/signUp",
    name: "signup",
    component: "SignUp",
    isPrivate: false,
  },
  {
    path: "/signup-with-socials",
    name: "SignUpWith",
    component: "SignUpWith",
    isPrivate: false,
  },
  {
    path: "/signup-with-email",
    name: "SignUpWithEmail",
    component: "SignUpWithEmail",
    isPrivate: false,
  },
  {
    path: "/signup-with-phone",
    name: "SignUpWithPhone",
    component: "SignUpWithPhone",
    isPrivate: false,
  },
  {
    path: "/sign-email-otp/:id",
    name: "SignUpWithOtp",
    component: "SignUpWithOtp",
    isPrivate: false,
  },
  {
    path: "/sign-phone-otp/:id",
    name: "SignUpWithPhoneOtp",
    component: "SignUpWithPhoneOtp",
    isPrivate: false,
  },
  {
    path: "/influancer-details/:id",
    name: "influencerdetail",
    component: "InfluencerDetail",
    isPrivate: true,
    role: "influencer",
  },
  {
    path: "/influencerprofile",
    name: "InfluencerProfile",
    component: "InfluencerProfile",
    isPrivate: false,
    role: "influencer",
  },
  {
    path: "/payment",
    name: "PaymentDashboard",
    component: "PaymentDashboard",
    isPrivate: true,
    role: "influencer",
  },
  {
    path: "/payment-method",
    name: "PaymentMethod",
    component: "PaymentMethod",
    isPrivate: true,
  },
  {
    path: "/Chatbot",
    name: "Chatbot",
    component: "Chatbot",
    isPrivate: true,
  },

  {
    path: "/myprofile",
    name: "myprofile",
    component: "MyProfile",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/notifications",
    name: "Notification",
    component: "Notification",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/insightcard",
    name: "Insightcard",
    component: "insightcard",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/insights",
    name: "Insights",
    component: "Insights",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/settings",
    name: "settings",
    component: "SettingsPage",
    isPrivate: true,
    role: "brand",
  },

  {
    path: "/dashboardqueries",
    name: "dashboardqueries",
    component: "DashboardQueries",
    isPrivate: true,
    role: "admin",
  },
  {
    path: "/contactsdashboard",
    name: "dashboard Home",
    component: "ContactsDashboard",
    isPrivate: true,
    role: "admin",
  },
  {
    path: "/admininsociaalorbit",
    name: "admin",
    component: "AdminDashboard",
    isPrivate: true,
    role: "admin",
  },
  {
    path: "/admin-brand-information",
    name: "admin brand information",
    component: "BrandDetailsadminDashboard",
    isPrivate: true,
    role: "admin",
  },
  {
    path: "/collab-request/:id",
    name: "CollabReqTable",
    component: "CollabReqTable",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/admin/influencers",
    name: "InfluencesApproval",
    component: "InfluencesApproval",
    isPrivate: true,
    role: "admin",
  },
  {
    path: "/admin/brand",
    name: "BrandApproval",
    component: "BrandApproval",
    isPrivate: true,
    role: "admin",
  },
  {
    path: "/subscription",
    name: "SubScriPtionMethod",
    component: "SubScriPtionMethod",
    // isPrivate: true,
  },
  {
    path: "/membership-upgrade",
    name: "MemberShipUpgrade",
    component: "MemberShipUpgrade",
    // isPrivate: true,
  },
  {
    path: "/view-brand-profile",
    name: "ViewBrandProfile",
    component: "ViewBrandProfile",
    isPrivate: true,
    role: "influencer",
  },
  {
    path: "/insights-deliverable",
    name: "insightsDeliverables",
    component: "insightsDeliverables",
    isPrivate: true,
    role: "brand",
  },
  {
    path: "/pricing",
    name: "AuthSubscription",
    component: "AuthSubscription",
    isPrivate: false,
  },
  {
    path: "/cancellation-policy",
    name: "Cancellation Policy",
    component: "CancellationPolicy",
    isPrivate: false,
  },
  {
    path: "/policy-nav",
    name: "PolicyNavbar",
    component: "PolicyNavbar",
    isPrivate: false,
  },

  {
    path: "/my-wallet",
    name: "MyWallet",
    component: "MyWallet",
    isPrivate: true,
  },
];
